export const BEAUTY_CAMPAIGN_CODE = "BEAUTY_100_2026";
export const BEAUTY_CAMPAIGN_PLAN = "start";
export const BEAUTY_CAMPAIGN_FREE_MONTHS = 12;
export const BEAUTY_CAMPAIGN_MAX = 100;
export const BEAUTY_CAMPAIGN_STARTER_MONTHLY = 39;
export const BEAUTY_CAMPAIGN_SAVINGS = BEAUTY_CAMPAIGN_STARTER_MONTHLY * BEAUTY_CAMPAIGN_FREE_MONTHS;

export type BeautyCampaignStatus = "SCHEDULED" | "ACTIVE" | "SOLD_OUT" | "ENDED" | "DISABLED";

export type PublicCampaign = {
    campaign: string;
    status: BeautyCampaignStatus;
    maxActivations: number;
    activated: number;
    remaining: number;
    startsAt?: string | null;
    endsAt?: string | null;
    plan: string;
    freeMonths: number;
    industryPreset?: string;
};

export const SESSION_MODAL_KEY = "tezam:beauty100:modal-shown";

export function isCampaignOfferActive(campaign: PublicCampaign | null | undefined): boolean {
    return campaign?.status === "ACTIVE" && campaign.remaining > 0;
}

export function isCampaignVisible(campaign: PublicCampaign | null | undefined): boolean {
    return campaign?.status === "ACTIVE" || campaign?.status === "SCHEDULED";
}

export function ruPlacesWord(count: number): "место" | "места" | "мест" {
    const n = Math.abs(Math.trunc(count));
    const n10 = n % 10;
    const n100 = n % 100;
    if (n10 === 1 && n100 !== 11) return "место";
    if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return "места";
    return "мест";
}

export function remainingPlacesLabel(remaining: number): string {
    return `${remaining} ${ruPlacesWord(remaining)} осталось`;
}

export function remainingPlacesOfMax(remaining: number, max: number): string {
    return `Осталось ${remaining} из ${max} ${ruPlacesWord(max)}`;
}

export function freePlacesBadge(remaining: number, max: number): string {
    if (remaining === max) return `${max} мест бесплатно`;
    return remainingPlacesLabel(remaining);
}

export function formatCampaignDate(iso?: string | null): string {
    if (!iso) return "";
    try {
        return new Intl.DateTimeFormat("ru-RU", {
            day: "numeric",
            month: "long",
            year: "numeric",
            timeZone: "Europe/Minsk",
        }).format(new Date(iso));
    } catch {
        return "";
    }
}

export const BEAUTY_CAMPAIGN_FAQ = [
    {
        question: "Почему TEZAM Beauty бесплатно?",
        answer:
            "В рамках программы BEAUTY 100 первые 100 новых Beauty-бизнесов получают тариф Starter бесплатно на 12 месяцев.",
    },
    {
        question: "Что именно бесплатно?",
        answer:
            "Тариф Starter: Telegram Mini App, CRM, онлайн-запись, услуги, клиенты, сотрудники и одна точка. Лимиты тарифа — до 20 услуг, 20 товаров и 3 сотрудников. Состав функций тот же, что у платного Starter.",
    },
    {
        question: "Нужна ли банковская карта?",
        answer: "Нет.",
    },
    {
        question: "Что произойдёт через 12 месяцев?",
        answer:
            "Бесплатный период закончится. Вы сможете выбрать актуальный тариф TEZAM. Без отдельно подключённого способа автосписания деньги автоматически не списываются.",
    },
    {
        question: "Можно ли пока оставить DIKIDI или YCLIENTS?",
        answer: "Да. TEZAM можно сначала использовать параллельно.",
    },
    {
        question: "Сайт тоже бесплатный?",
        answer:
            "Нет. Beauty Starter предоставляется бесплатно по акции. Собственный сайт является отдельной дополнительной услугой.",
    },
] as const;
